/** @module csi/action/Download */
define([
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory"
], function(def,Action,ActionFactory) {

	var DOWNLOAD = "Download";
	
	return ActionFactory.declare(DOWNLOAD, Action, {
		constructor: function(obj) {
			this.m_tag = this.m_tag || DOWNLOAD;
			this.m_typeControl = this.m_typeControl || def.ACTION_BUTTON;

			// only draw as submit button if it does not use a popup view
			this.m_bSubmit = !this.m_viewRef;
		},

		/**
		 * @override
		 * This action must be configured with a Request
		 */
		isValid: function() {
			return this.m_request && this.inherited(arguments);
		}
	});
});